import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { SaleOffersChartResponse } from 'src/app/models/ISaleOffersChartResponse';
import { BranchPerformanceResponse } from 'src/app/models/IBranchPerformanceData';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class SalesPerformanceDashboardService {

  private baseURL = environment.apiURL;

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get Recent sale offers
   * @returns Array
   */
  public getRecentSaleOffers():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/sales-performance/recent-sale-offers`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Get Sales Rep's performance
   * @returns Array
   */
  public getSalesRepsPerformance(selectedPeriod:string):Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/sales-performance/sales-reps-performance?period=${selectedPeriod}`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Get Sale Offers by Customer Category
   * @returns Array
   */
  public getSaleOffersByCustomerCategory(selectedPeriod:string):Observable<SaleOffersChartResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/sales-performance/sale-offers-by-customer-category?period=${selectedPeriod}`;

    return this.http.get<SaleOffersChartResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Get Sale Offers by Customer Type
   * @returns Array
   */
  public getSaleOffersByCustomerType(selectedPeriod:string):Observable<SaleOffersChartResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/sales-performance/sale-offers-by-customer-type?period=${selectedPeriod}`;

    return this.http.get<SaleOffersChartResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Get Sales Performance by branch
   * @returns Array
   */
  public getSalesPerformanceByBranch(selectedPeriod:string):Observable<BranchPerformanceResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/sales-performance/sales-performance-by-branch?period=${selectedPeriod}`;

    return this.http.get<BranchPerformanceResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }
}
